module.exports = __webpack_public_path__ + "img/bulk_samples.d6a3ab84.svg";